/**
 * 角色管理模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  // 获取所有用户,检测手机号重复
  {
    name: 'getUserAll',
    url: '/api/aam/v1/mgmt/users'
  },
  // 检测邮箱是否重复
  {
    name: 'checkUser',
    url: '/api/aam/v1/mgmt/repeat/user'
  },
  // 获取当前用户信息
  {
    name: 'getUserInfo',
    url: '/api/aam/v1/portal/user/info'
  },
  // 获取用户头像 type=1为头像 2为主题
  {
    name: 'getAvatar',
    url: '/api/aam/v1/mgmt/users/attribute',
    defaultParams: {
      type: 1
    }
  },
  // 修改用户头像 userId
  {
    name: 'putAvatar',
    url: '/api/aam/v1/mgmt/users/attribute/{@}',
    defaultParams: {
      type: 1
    },
    method: 'PUT'
  },
  // 修改用户信息 userId
  {
    name: 'putUser',
    url: '/api/aam/v1/mgmt/users/{@}',
    method: 'PUT'
  },
  // 获取当前用户权限码
  {
    name: 'getPermissionCodes',
    url: '/api/aam/v1/portal/user/resource'
  },
  // 删除用户userId
  {
    name: 'delUser',
    url: '/api/aam/v1/mgmt/users/{@}',
    method: 'DELETE'
  },
  // 通过验证码修改手机号
  {
    name: 'setPhone',
    url: '/api/sms-api/v1/code/valid',
    method: 'POST',
    defaultParams: {
      type: 2
    },
    json: true
  },
  // 通过验证码修改密码
  {
    name: 'setPass',
    url: '/api/sms-api/v1/code/valid',
    method: 'POST',
    defaultParams: {
      type: 3
    },
    json: true
  },
  //  通过腾讯发送短信 2修改手机号  3修改密码
  {
    name: 'sendTxMsg',
    url: '/api/sms-api/v1/tencent/sms',
    method: 'GET'
  },
  // 验证旧密码
  {
    name: 'checkPass',
    url: '/api/aam/v1/mgmt/valid/password',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  // 修改用户默认组织userId
  {
    name: 'putUserOrgan',
    url: '/api/aam/v1/mgmt/users/{@}/groups/orgs/government',
    method: 'PUT',
  },
  // 获取用户绑定的组织、部门、角色
  {
    name: 'getUserOrgan',
    url: '/api/aam/v1/mgmt/user/relation/group/role',
    method: 'GET'
  },
]
